module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('pageTitle', {
    attrs: {
      "title": "代金券规则说明"
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._v("\n        1.会员可通过手机邮箱激活验证、格林币兑换、参加官网及APP活动等途径获取电子代金券。"), _c('br'), _c('br'), _vm._v("\n        2.每张电子代金券根据不同获取途径有效期不同，具体有效截止日期以网上会员账户界面电子代金券查询显示为准。"), _c('br'), _c('br'), _vm._v("\n        3.电子代金券仅限通过998.com或APP预订抵扣，可抵扣的酒店及房型以酒店房型预订页面代金券栏标示为准。"), _c('br'), _c('br'), _vm._v("\n        4.每间夜预订限使用1张电子代金券，每间夜可抵扣限额以预订界面标示为准，代金券面额超出可抵扣限额的部分不找零。"), _c('br'), _c('br'), _vm._v("\n        5.使用电子代金券的订单不能再享受生日礼遇及其他活动优惠。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-076a9b39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/vocherExplain.vue
// module id = 1411
// module chunks = 18